/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForSaasOnboarded extends models.ServiceAccountCredentialsBaseForSaas {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForSaasOnboarded");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForSaasOnboarded.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForSaasOnboarded>): ServiceAccountCredentialsForSaasOnboarded {
        let obj = Object.assign(new ServiceAccountCredentialsForSaasOnboarded(), model);
        ServiceAccountCredentialsForSaasOnboarded.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForSaasOnboarded>): ServiceAccountCredentialsForSaasOnboarded {
        if (!model) return null;
        return ServiceAccountCredentialsForSaasOnboarded.newInstance(<ServiceAccountCredentialsForSaasOnboarded> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForSaasOnboarded) {
        if (!obj) return;

        models.ServiceAccountCredentialsForSaasOnboarded.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForSaasOnboarded): boolean {
        if (models.ServiceAccountCredentialsBaseForSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForSaasOnboarded.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
